"use client";

import React, { Fragment, Suspense } from "react";
import {
  useWidth,
  useMobileMenu,
} from "@/hooks";
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/authContext";
// import storeMarketplaceEvents from "@/hooks/web3Hooks/thirdweb/storemarketplaceEvents.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Header from "@/components/partials/header";
import Sidebar from "@/components/partials/sidebar";
import MobileMenu from "@/components/partials/sidebar/MobileMenu";
import Footer from "@/components/partials/footer";
import TopBar from "@/components/refactored/header/top-bar";
import LoadingTransparent from "@/components/Loading-Transparent";

export default function RootLayout({ children }) {
  const { isAuthenticated, isFetchingUser, walletAddress } = useAuth();

  const { width, breakpoints } = useWidth();

  const [mobileMenu, setMobileMenu] = useMobileMenu();
  // const { processedEvents } = storeMarketplaceEvents(walletAddress);

  const topBarHeight = 56;
  const contentWrapperAuthStyle = {
    marginTop: `${-(topBarHeight * 1.7142)}px`,
  };
  const contentWrapperNonAuthStyle = {
    marginTop: `${-(topBarHeight * 1.3571)}px`,
  };
  const contentWrapperOtherStyle = { marginTop: `${-(topBarHeight * 0.75)}px` };



  return (
    <Fragment>
      <ToastContainer
       position="top-right"
       autoClose={5000}
       newestOnTop={false}
       closeOnClick={false}
       rtl={false}
       pauseOnFocusLoss
       draggable={false}
       theme="dark"
       style={{ zIndex: 1100000 }}
       limit={1}
      />
      <div className="wrapper-of-wrappers overflow-clip">
        {/* TOP BAR */}
        <TopBar style={{ height: `${topBarHeight}px` }} />
        {/* TOP BAR */}

        <main
          dir={"ltr"}
          className={`relative app-warp dark ${
            "skin--default"
          }  `}
        >
          <Header
            className={width > breakpoints.xl ? " ltr:ml-[248px] rtl:mr-[248px] " : ""}
          />
          {width > breakpoints.xl && (
            <Sidebar />
          )}

          <MobileMenu
            className={`${
              width < breakpoints.xl && mobileMenu
                ? "left-0 visible opacity-100  z-[99999]"
                : "left-[-300px] invisible opacity-0  z-[-999] "
            }`}
          />
          {width < breakpoints.xl && mobileMenu && (
            <div
              className="overlay backdrop-filter backdrop-blur-sm opacity-100 fixed inset-0 z-[999]"
              onClick={() => setMobileMenu(false)}
            ></div>
          )}

          <div
            className={`content-wrapper min-h-screen ${
              width > 1280 ? " ltr:ml-[248px] rtl:mr-[248px] " : ""
            }`}
            style={
              width > 1024
                ? !isFetchingUser && isAuthenticated
                  ? contentWrapperAuthStyle
                  : !isFetchingUser && !isAuthenticated
                  ? contentWrapperNonAuthStyle
                  : contentWrapperOtherStyle
                : {}
            }
          >
            <div className="page-content page-min-height">
              <div
                className={"container-fluid"}
              >
                <motion.div
                  initial="pageInitial"
                  animate="pageAnimate"
                  exit="pageExit"
                  variants={{
                    pageInitial: {
                      opacity: 0,
                      y: 50,
                    },
                    pageAnimate: {
                      opacity: 1,
                      y: 0,
                    },
                    pageExit: {
                      opacity: 0,
                      y: -50,
                    },
                  }}
                  transition={{
                    type: "tween",
                    ease: "easeInOut",
                    duration: 0.5,
                  }}
                >
                  <Suspense fallback={<LoadingTransparent />}>
                    {children}
                  </Suspense>
                </motion.div>
              </div>
            </div>
          </div>
          <Footer
            className={width > breakpoints.xl ? " ltr:ml-[248px] rtl:mr-[248px] " : ""}
          />
        </main>
      </div>
    </Fragment>
  );
}
